<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <span *ngIf="currentStatus === 'tous'">({{ getStatusCount('Tous') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <span *ngIf="currentStatus === 'brouillon'">({{ getStatusCount('Brouillon') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/paye']" [class.active]="currentStatus === 'paye'" (click)="filterByStatus('paye')">
                    Payé <span *ngIf="currentStatus === 'paye'">({{ getStatusCount('Payé') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/non_payé']" [class.active]="currentStatus === 'non_payé'" (click)="filterByStatus('non_payé')">
                    Non Payé <span *ngIf="currentStatus === 'non_payé'">({{ getStatusCount('Non payé') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <span *ngIf="currentStatus === 'annule'">({{ getStatusCount('Annulé') }})</span>
                </a>
            </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/vente/facture/part-paye']" [class.active]="currentStatus === 'partPaye'" (click)="filterByStatus('partPaye')">
                Partiellement payé <span *ngIf="currentStatus === 'partPaye'">({{ getStatusCount('Partiellement payé') }})</span>
            </a>
        </li>
        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>

